module.exports = __webpack_public_path__ + "img/Understand_annotation.c67c3a4f.png";